// components
import React, { useEffect, useState } from 'react';
import Kitchen from './Kitchen';

import {getKitchens} from '../../../services/kitchenService';
import { FOOD_TYPE_LABELS } from '../../../constants';

import { useUser } from '../../../UserContext';
import { useAuth } from '../../../AuthContext';
import { useSnackbar } from '../../shared/SnackbarContext';
import { useOrderEvents } from '../../shared/OrderEventsContext';

import hubWebSocketService from '../../../services/hubWebSocketService';
import { getHubMessageFromJson } from '../../../utils/hubCommonFunctions';

// mui
import Chip from '@mui/material/Chip';

export default function OpenKitchenList(props) {

    const [kitchenList, setKitchenList] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedFoodType, setSelectedFoodType] = useState('all');
    const { user } = useUser();
    const { auth } = useAuth();
    const { showMessage } = useSnackbar();
    const { triggerRefreshOrders } = useOrderEvents();

    function connectCustomerToHub(customerId) {
          hubWebSocketService.connect({
                clientId: `cus-${customerId}`,
                token: auth,
                onMessage: (msg) => { 
                  const message = getHubMessageFromJson(msg);
                  if (message) {
                      showMessage(message, 'info');
                      triggerRefreshOrders();
                  }
                },
          });
    }

    useEffect(() => {
        const getKitchenList = async () => {
            try {
                const responseData = await getKitchens(auth);
                setKitchenList(responseData);
                if (props.onKitchenListRetrieval) {
                    props.onKitchenListRetrieval(responseData);
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        if (user && user.customer && user.customer.id) {
            connectCustomerToHub(user.customer.id);
        }

        getKitchenList();
    }, [user]);

    if (loading) {
        return <div>Loading data...</div>;
    }

    if (error) {
        return <div>Sorry, something went wrong. {error}</div>;
    }

    // If Home provides a location-filtered list, always respect it (even when empty)
    const hasLocationFiltering = Array.isArray(props.filteredLocations) && props.userCoords?.latitude;
    const displayKitchens = hasLocationFiltering ? props.filteredLocations : kitchenList;
    const filteredKitchens = selectedFoodType === 'all'
        ? displayKitchens
        : displayKitchens?.filter((kitchen) => kitchen.menus?.some((menu) => menu.type === selectedFoodType));

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: 8, flexWrap: 'wrap' }}>
                <Chip
                    label="All"
                    clickable
                    color={selectedFoodType === 'all' ? 'primary' : 'default'}
                    variant={selectedFoodType === 'all' ? 'filled' : 'outlined'}
                    onClick={() => setSelectedFoodType('all')}
                />
                {Object.entries(FOOD_TYPE_LABELS).map(([type, label]) => (
                    <Chip
                        key={type}
                        label={label}
                        clickable
                        color={selectedFoodType === type ? 'primary' : 'default'}
                        variant={selectedFoodType === type ? 'filled' : 'outlined'}
                        onClick={() => setSelectedFoodType(type)}
                    />
                ))}
            </div>
            <div data-testid="kitchen-list-id" style={{ display: 'flex', flexDirection: 'row', gap: 16, flexWrap: 'wrap', maxWidth: 930}}>
                {filteredKitchens && filteredKitchens.length > 0 ? (
                    filteredKitchens.map((kitchen) => {
                        return (
                            <Kitchen 
                                key={kitchen.id}
                                kitchenData={kitchen}
                            />
                        );
                    })
                ) : (
                    <div style={{ color: 'gray', padding: 16 }}>
                        {selectedFoodType === 'all'
                            ? 'No kitchens found within the selected distance. Try increasing the search radius.'
                            : 'No kitchens found for the selected food type.'}
                    </div>
                )}
            </div>
        </div>
    )
}